/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSickle: {
  name: 'sickle';
  data: string;
} = {
  name: 'sickle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M136.295 423.327c-23.364 2.161-32.592 14.934-35.254 30.895l65.112 62.407.935.978.043-.042 8.747 8.384c21.785-2.002 34.507-12.375 32.1-31.657l-71.683-70.965zM36.342 532.256c-20.005 32.27 17.579 73.136 61.088 53.366l61.071-59.632-53.637-56.156-68.522 62.422zM307.852 30.056c422.137 330.946 20.24 488.762-105.021 350.53l-50.309 45.831 52.097 54.543 2.538-2.479C467.545 712.24 847.354 185.371 307.852 30.056z"/></svg>`,
};
